class Header {
  constructor($el) {
    this.$el = $el;
    this.$toggler = $el.querySelector('.nav__toggler');
    this.body = document.body;
    this.$toggler.addEventListener('click', this.onToggleNav.bind(this));
  }

  onToggleNav() {
    if (this.$el.classList.contains('header--closed')) {
      this.$el.classList.remove('header--closed');
      this.$el.classList.add('header--open');
      this.body.style.overflow = 'hidden';
    } else {
      this.$el.classList.remove('header--open');
      this.$el.classList.add('header--closed');
      this.body.style.overflow = 'auto';
    }
  }
}

export default Header;
